// extracted by mini-css-extract-plugin
module.exports = {"plp-resultList":"result-listing_plp-resultList__Qj5JM"};